import { render, staticRenderFns } from "./FormSelect.vue?vue&type=template&id=52c2e1d9&scoped=true"
import script from "./FormSelect.vue?vue&type=script&lang=ts"
export * from "./FormSelect.vue?vue&type=script&lang=ts"
import style0 from "./FormSelect.vue?vue&type=style&index=0&id=52c2e1d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c2e1d9",
  null
  
)

export default component.exports